<div class="tp-wrapper">
  <table class="tp-table">
    <thead class="tp-header">
    <tr>
      <th class="tp-header-cell">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono paciente" svgIcon="avatar-contrast"></mat-icon>
            <span class="tp-header-text">Nombre y apellido</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono calendario" svgIcon="calendar-info-consulta"></mat-icon>
            <span class="tp-header-text">Fecha</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono calendario" svgIcon="hospital-table"></mat-icon>
            <span class="tp-header-text">Tipo de consulta</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono historial" svgIcon="estado-consulta"></mat-icon>
            <span class="tp-header-text">Estado de la consulta</span>
          </span>
      </th>
      <th class="tp-header-cell tp-text-center">
          <span class="tp-header-content">
            <mat-icon aria-hidden="false" aria-label="Icono historial" svgIcon="health-contrast"></mat-icon>
            <span class="tp-header-text">Archivos de la consulta</span>
          </span>
      </th>
    </tr>
    </thead>

    <tbody>
      @for ( item of list() ; track item.idAtencion; let idx = $index ) {
        <tr class="tp-row-divider tp-last-row-no-divider">
          <td class="tp-cell">
            {{ item.completeName }}
          </td>

          <td class="tp-cell tp-text-center">
            {{ item.date | date:'dd/MM/yyyy' }}
          </td>

          <td class="tp-cell tp-text-center">
            <div
              class="chip-tipo-consulta"
              [class.presencial]="item.type === 'PRESENCIAL'"
              [class.telemedicina]="item.type === 'TELEMEDICINA'"
              [class.domiciliaria]="item.type === 'DOMICILIARIA'"
            >
              @switch ( item.type ) {
                @case ( 'PRESENCIAL' ) {
                  <img src="assets/icons/hospital.svg" alt="Presencial"/>
                }
                @case ( 'TELEMEDICINA' ) {
                  <img src="assets/icons/telemedicina.svg" alt="Telemedicina" />
                }
                @case ( 'DOMICILIARIA' ) {
                  <img src="assets/icons/house.svg" alt="Domiciliaria" />
                }
              }

              <p>{{ capitalizeName( item.type ) }}</p>
            </div>
          </td>

          <td class="tp-cell tp-text-center">
            <div
              [class.estado-consulta]="true"
              [class.realizada]="item.status === 'REALIZADA'"
              [class.suspendida]="item.status === 'SUSPENDIDA'"
              [class.anulada]="item.status === 'ANULADA'"
            >
              @switch ( item.status ) {
                @case ( 'REALIZADA' ) {
                  <img src="assets/icons/check_icon.svg" alt="Consulta realizada"/>
                }
                @case ( 'ANULADA' ) {
                  <img src="assets/icons/cancel.svg" alt="Consulta anulada"/>
                }
                @case( 'SUSPENDIDA' ) {
                  <img src="assets/icons/delete.svg" alt="Consulta suspendida"/>
                }
              }

              <p class="texto-chip">
                Consulta {{ item.status.toLocaleLowerCase() }}
              </p>
            </div>
          </td>

          <td class="tp-cell tp-text-center dropdown-cell">
            @switch ( item.status ) {
              @case ( 'REALIZADA' ) {
                <button
                  type="button"
                  class="ver-documentos-btn"
                  (click)="toggleMenu( item, $event )"
                  aria-label="Ver documentos"
                >
                  Ver documentos
                  <span class="three-dots"> {{ isMenuOpen() === item.idAgendamiento ? 'X' : '⋮' }} </span>
                </button>
              }
              @default {
                <button
                  type="button"
                  class="ver-documentos-btn document-disabled"
                  aria-label="Ver documentos disabled"
                >
                  Ver documentos
                  <span class="three-dots text-disabled"> ⋮ </span>
                </button>
              }
            }
          </td>
        </tr>
      }
    </tbody>
  </table>


</div>
